/* eslint-disable eqeqeq */
import { Component } from "react";
import "react-datetime/css/react-datetime.css";
import IBSService from "../Services/IBSService";
import {
  Appointment as IAppointment,
  Checklist,
  Email
} from "../modals/Appointment";
import Appointment from "./Appointment/Appointment";
import { format } from "date-fns";
import BookingStepper from "./Stepper/BookingStepper";
import BookingCalendar from "./BookingCalendar/BookingCalendar";
import { IBodyshopService } from "../UserService";
import moment, { Moment } from "moment";
import Summary from "./Summary/Summary";
import DisplayBooking from "./DisplayBooking/DisplayBooking";
import { Message } from "semantic-ui-react";
import MessageDialog from "../Message/Message";
import { TaskPayload } from "../modals/TaskPayload";
import { deleteBookingTask } from "../Services/TaskService";
import PickUp from "./PickUp/PickUp";
import {
  Button,
  Grid,
  GridItem,
  Text,
  Alert,
  AlertIcon
} from "@chakra-ui/react";
import _ from "lodash";
import APIService from "../Services/APIService";
import CancelBooking from "./CancelBooking/CancelBooking";
import { JobEstimationDetail } from "../modals/JobEstimationDetail";
import { IBSAdonisService } from "../Services/IBSAdonisService";
import { BookingState } from "../modals/StateInterface/BookingState";
import { Mixpanel } from "../Services/MixPanel";
import { CommonMethodService } from "../Services/CommonMethodService";
import { BookingAllowance } from "../modals/BookingAllowance";

require("./Booking.css");

interface BookingProps {
  estimateDetails: JobEstimationDetail;
  updateEstimateDetails: Function;
}

export default class Booking extends Component<BookingProps, BookingState> {
  repairCalendarId: string = "4e4e14c7-45c7-4f54-8724-2a30aac8e61d";
  taskListId: string = "c96b91ab-7662-4533-8172-5e1e387ea918";

  private ibsService = new IBSService();
  private iBodyShopService = new IBodyshopService();
  private apiService = new APIService();
  private ibsAdonisService = new IBSAdonisService();
  private commonMethodService = new CommonMethodService();

  appointments: IAppointment[] = [];
  appointmentsDates: IAppointment[] = [];

  allData: any[] = [];
  selectedDayData: any = {};

  selectedAppointment: IAppointment | null = null;
  selectedChecklist: Checklist | null = null;

  // defaultSMS: string = "954077a3-3074-4ca9-86eb-d481f15a8f25"; // review message template
  defaultSMS: string = "2d86f2dd-c7ea-4f6a-85a2-4968140f588a"; // confirm message template
  // defaultEmail: string = "2176e048-5976-484f-8e86-49bb00068c78"; // review email template
  defaultEmail: string = "40f154f5-4321-4fa9-8815-6e31d4ba6f26"; // confirm email template

  constructor(props: BookingProps) {
    super(props);

    this.state = {
      showDetails: false,
      data: format(new Date(), "ccc dd MMM yy"),
      estimateDetails: props.estimateDetails,
      appointments: [],
      allAppointments: [],
      showLoader: true,
      step: 1,
      bookingDate: null,
      bookingSlot: null,
      isBooked: !!props.estimateDetails?.expectedArrival,
      bookingSuccessful: false,
      showConfirmation: false,
      slots: [],
      isRevised: false,
      isVehicleOnSite: !props.estimateDetails.isVehicleOnSite,
      showConfirmationOfCancelBooking: false,
      bookingCancel: false,
      canceledReason: "",
      bookingDateError: "",
      bookingMessage: null,
      bookingAllowance: {
        estimatedArrivalStartInterval: 0,
        estimatedCompletion: 0,
        estimatedCompletionCollectionInterval: 0
      }
    };
    this.getAppointments();
    this.getPredictedWorkTime();
  }

  async getAppointments() {
    this.setState({
      appointments: [],
      allAppointments: []
    });
    try {
      await this.apiService.getBookingDays().then(async (res) => {
        if (res.ok) {
          const data = await res.json();
          this.allData = data.data;
          const appointments = await this.checkAppointment(
            this.allData,
            new Date(this.state.data)
          );
          if(appointments && appointments.length <= 0){
            Mixpanel.track("Get Appointment Empty", {
              status: "Data not fetched"
            });
          }

          this.appointments = appointments;

          this.setState({
            allAppointments: appointments,
            appointments: appointments,
            showLoader: false
          });
          Mixpanel.track("Get Appointment", {
            data,
            status: "Data fetched"
          });
        } else {
          if (res.status === 401) {
            // this.iBodyShopService.logout();
            // window.location.reload();
          }
          this.setState({
            allAppointments: [],
            appointments: [],
            showLoader: false
          });
          Mixpanel.track("Get Appointment", {
            error: res,
            status: res?.status
          });
        }
      });
    } catch (ex) {
      this.setState({
        allAppointments: [],
        appointments: [],
        showLoader: false
      });
      Mixpanel.track("Get Appointment", {
        error: ex,
        status: "Something went wrong"
      });
    }
  }

  async getPredictedWorkTime() {
    try {
      // Fetch estimated repair days from IBS service
      const estimatePlanningResponse =
        await this.ibsService.getEstimatePlanning(
          this.props.estimateDetails.estimateId
        );
      const estimatePlanningResult = await estimatePlanningResponse.json();

      // Set state with initial estimated completion
      this.setState({
        bookingAllowance: {
          estimatedCompletion:
            estimatePlanningResult.suggestedRepairDaysRequired,
          estimatedArrivalStartInterval: 3, // Default or fetch from data
          estimatedCompletionCollectionInterval: 3 // Default or fetch from data
        }
      });
      // Fetch booking allowance from the API service
      const bookingAllowanceResponse =
        await this.apiService.getBookingAllowance();

      if (bookingAllowanceResponse.ok) {
        const bookingAllowanceData = await bookingAllowanceResponse.json();

        if (bookingAllowanceData && bookingAllowanceData.data.length > 0) {
          const bookingAllowance: BookingAllowance =
            bookingAllowanceData.data[0];

          // Update state with adjusted values based on conditions
          this.setState({
            bookingAllowance: {
              estimatedCompletion:
                estimatePlanningResult.suggestedRepairDaysRequired > 0
                  ? estimatePlanningResult.suggestedRepairDaysRequired
                  : bookingAllowance?.estimatedCompletion || 5,
              estimatedArrivalStartInterval:
                bookingAllowance?.estimatedArrivalStartInterval > 0
                  ? bookingAllowance.estimatedArrivalStartInterval
                  : 3,
              estimatedCompletionCollectionInterval:
                bookingAllowance?.estimatedCompletionCollectionInterval > 0
                  ? bookingAllowance.estimatedCompletionCollectionInterval
                  : 3
            }
          });
        }
      }
    } catch (error) {
      Mixpanel.track("Get PredictedWorkTime Error", {
        error,
        status: "Something went wrong"
      });
    }
  }

  async checkAppointment(
    appointments: IAppointment[],
    date: Date
  ): Promise<IAppointment[]> {
    let availableAppointments: IAppointment[] = [];
    if (appointments.length && this.state.estimateDetails) {
      const estimateWorkType: string = this.state.estimateDetails.workType
        ? this.state.estimateDetails.workType
        : "Retail";

      appointments.filter((appointment: any) => {
        const date = moment(appointment.date);
        if (date.isSameOrAfter(new Date(), "day")) {
          return appointment.slots.forEach((slot: any) => {
            if (
              slot.workType.name === estimateWorkType &&
              slot.booking_id === null
            ) {
              const slotDate = { dueDate: appointment.date };
              slot = { ...slot, ...slotDate };
              return availableAppointments.push(slot);
            }
          });
        }

        return null;
      });
    }
    availableAppointments = _.uniqBy(availableAppointments, "dueDate");
    return availableAppointments;
  }

  stepChange(step: number) {
    if (
      ((this.state.step === 1 && !this.state.bookingDate) ||
        (this.state.step === 2 && !this.state.bookingSlot)) &&
      step > 0
    ) {
      if (this.state.step === 1 && !this.state.bookingDate) {
        this.setState({ bookingDateError: "Please select date first" });
      } else {
        this.setState({ bookingDateError: "Please select time first" });
      }
    } else {
      this.setState({ bookingDateError: "" });
      if (this.state.step + step >= 1 && this.state.step + step <= 3) {
        this.setState({
          step: this.state.step + step
        });
      }
    }
  }

  onDateSelected = (date: Moment) => {
    if (date && this.state.estimateDetails) {
      this.setState({ bookingDateError: "" });
      this.selectedAppointment = this.state.appointments.filter((x: any) => {
        return moment(moment(x.dueDate).format("YYYY-MM-DD")).isSame(
          date.format("YYYY-MM-DD"),
          "day"
        );
      })[0];

      this.selectedDayData = this.allData.find((data: any) => {
        return moment(data.date).isSame(date, "day");
      });

      const dropOffTimes = this.allData.find((slot: any) => {
        return slot.id === this.selectedAppointment?.booking_day_id;
      });

      let times = dropOffTimes.bookingDayDropOffTime.map((dropOff: any) => {
        return {
          time: moment(
            moment(dropOffTimes.date).format("YYYY-MM-DD") +
              "T" +
              dropOff.drop_off
          ).format("hh:mm A"),
          id: dropOff.id
        };
      });

      times = _.orderBy(times, "time");
      this.setState({
        slots: times,
        bookingDate: date
      });
    }
    Mixpanel.track("User Select Date", {
      date: moment(date).format("YYYY-MM-DD"),
      estimateDetail: this.state.estimateDetails
    });
  };

  slotsCalculator = (startStr: any, endStr: any) => {
    var x = 60; // minutes interval
    var times = []; // time array
    var tt = startStr * 60; // start time
    var ee = endStr * 60;
    var ap = ["AM", "PM"]; // AM-PM

    //loop to increment the time and push results in array
    for (var i = 0; tt <= ee; i++) {
      var hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
      var mm = tt % 60; // getting minutes of the hour in 0-55 format
      times[i] = {
        time:
          ("0" + (hh % 12 === 0 ? 12 : hh % 12)).slice(-2) +
          ":" +
          ("0" + mm).slice(-2) +
          " " +
          ap[Math.floor(hh / 12)]
      }; // pushing data in array in [00:00 - 12:00 AM/PM format]
      tt = tt + x;
    }

    this.setState({
      slots: times
    });
  };

  onSlotPicked = (slot: any) => {
    if (slot) {
      this.setState({
        bookingSlot: slot,
        bookingDateError: ""
      });
    }
    Mixpanel.track("User Select Slot", {
      slot: slot,
      estimateDetail: this.state.estimateDetails
    });
  };

  saveBooking = async (revise?: boolean) => {
    // Start loader here
    this.setState({
      showLoader: true
    });

    await this.addTask();

    await this.booking();

    await this.updateChecklist(revise);

    await this.sendEmails();

    await this.sendNotification(false, revise);

    await this.sendDefaultSMS();

    this.reloadEstimate();
    this.getPredictedWorkTime();
  };

  async addTask() {
    let url = `https://portal.flowautobody.com.au/?estimateid=${this.state.estimateDetails?.estimateNumber}&step=booking`;
    let arrayOfCheckListItems = [];
    let array = [
      "Job issue",
      "Order parts",
      "Complete key tile",
      "Print job sheet"
    ];
    for (let value of array) {
      arrayOfCheckListItems.push({
        caption: value,
        isChecked: false,
        id: "",
        isDeleted: false,
        isRenamed: false
      });
    }
    const taskObj: TaskPayload = {
      Title: `${
        this.state.estimateDetails?.ownerName != null
          ? this.state.estimateDetails?.ownerName
          : ""
      } - ${this.state.estimateDetails?.estimateNumber} (${url})`,
      assignments: [
        {
          id: this.state.estimateDetails.estimateId,
          userName: this.state.estimateDetails.estimateNumber.toString(),
          type: "Estimate",
          lastStarted: new Date(),
          isDeleted: false
        }
      ],
      AssignDate: new Date(),
      additionalNote: `Booking Date: ${this.state.bookingDate}\nBooking Slot: ${this.state.bookingSlot.time}`,
      checklistItems: arrayOfCheckListItems
    };

    const resp = await this.ibsService.addTask(this.taskListId, taskObj);
    if (resp.ok) {
      Mixpanel.track("Task List Added", {
        taskListId: this.taskListId,
        taskObj: taskObj,
        estimateDetail: this.state.estimateDetails,
        status: "Task added successfully"
      });
    } else {
      Mixpanel.track("Task List Added Error", {
        taskListId: this.taskListId,
        taskObj: taskObj,
        estimateDetail: this.state.estimateDetails,
        error: resp,
        status: "Task not added"
      });
    }
  }

  async booking() {
    let expectedArrival = "";
    if (this.state.bookingDate && moment(this.state.bookingDate).isValid()) {
      expectedArrival = this.getExpectedArrivalDate();
    }
    let expectedStart = this.commonMethodService.getPredictingWorkDate(
      expectedArrival,
      this.state.bookingAllowance.estimatedArrivalStartInterval
        ? this.state.bookingAllowance.estimatedArrivalStartInterval
        : 3
    ).date;
    let expectedEnd = this.commonMethodService.getPredictingWorkDate(
      expectedStart,
      this.state.bookingAllowance.estimatedCompletion
        ? this.state.bookingAllowance.estimatedCompletion
        : 5
    ).date;
    let expectedPickup = this.commonMethodService.getPredictingWorkDate(
      expectedEnd,
      this.state.bookingAllowance.estimatedCompletionCollectionInterval
        ? this.state.bookingAllowance.estimatedCompletionCollectionInterval
        : 3
    ).date;
    let date = new Date().toDateString();
    const bookingPayload = {
      aggregateRootId: this.state.estimateDetails.estimateId,
      expectedArrival,
      expectedStart,
      expectedEnd,
      expectedPickup,
      repairDaysRequired: this.state.estimateDetails?.jobBookingId
        ? this.state.estimateDetails?.repairDaysRequired
        : "",
      bookingId: this.state.estimateDetails?.jobBookingId
        ? this.state.estimateDetails?.jobBookingId
        : null,
      jobId: this.state.estimateDetails.jobId,
      arrivalNotes: `The booking has been created from the customer portal on ${date}`
    };

    await this.iBodyShopService
      .booking(bookingPayload)
      .then(async (res: any) => {
        if (res.ok) {
          res.json().then((resJSON: any) => {
            if (resJSON.IsSuccess) {
              this.setState({
                bookingSuccessful: true,
                bookingMessage: "Your booking details have been saved"
              });
              Mixpanel.track("Appointment Booked", {
                bookingObj: bookingPayload,
                estimateDetail: this.state.estimateDetails,
                status: "Appointment booked successfully"
              });
            } else {
              this.setState({
                bookingSuccessful: false,
                showLoader: false,
                bookingMessage:
                  "Your booking details have not been saved, Please try again."
              });
              Mixpanel.track("Appointment Booked Error", {
                bookingObj: bookingPayload,
                error: resJSON,
                estimateDetail: this.state.estimateDetails,
                status: "Appointment not booked"
              });
              this.reloadEstimate();
              return;
            }
          });
        } else {
          const resp = await res.json();
          this.setState({
            bookingSuccessful: false,
            showLoader: false,
            bookingMessage:
              "Your booking details have not been saved, Please try again."
          });
          Mixpanel.track("Appointment Booked Error", {
            bookingObj: bookingPayload,
            exceptionError: resp.Message,
            estimateDetail: this.state.estimateDetails,
            status: "Appointment not booked"
          });
          this.reloadEstimate();
          return;
        }
      })
      .catch((ex) => {
        this.setState({
          bookingSuccessful: false,
          showLoader: false,
          bookingMessage:
            "Your booking details have not been saved, Please try again."
        });
        Mixpanel.track("Appointment Booked Error", {
          bookingObj: bookingPayload,
          exceptionError: ex,
          estimateDetail: this.state.estimateDetails,
          status: "Appointment not booked"
        });
        this.reloadEstimate();
        return;
      });
  }

  getExpectedArrivalDate() {
    const bookingDateMoment = moment(this.state.bookingDate);
    const bookingTimeMoment = moment(this.state.bookingSlot.time, "HH:mm");

    // Combine date and time
    const combinedDateTimeMoment = moment({
      year: bookingDateMoment.year(),
      month: bookingDateMoment.month(),
      date: bookingDateMoment.date(),
      hour: bookingTimeMoment.hour(),
      minute: bookingTimeMoment.minute()
    });

    // Format the combined date and time
    return combinedDateTimeMoment.format("YYYY-MM-DDTHH:mm");
  }

  async updateChecklist(revise?: boolean) {
    if (this.selectedAppointment) {
      let bookingSlot = {
        bookingDayId: this.selectedAppointment.booking_day_id,
        bookingDayDropOffTimeId: this.state.bookingSlot.id,
        jobExternalId: this.state.estimateDetails.estimateId,
        slots: [
          {
            id: this.selectedAppointment.id
          }
        ],
        confirmed: false
      };

      let bookingSlotId: any;
      const res: any = await this.apiService.getBookingForId(
        this.state.estimateDetails.estimateId
      );
      await res.json().then((resJSON: any) => {
        if (resJSON.data && resJSON.data[0]) {
          bookingSlotId = resJSON.data[0].id;
        }
      });

      if (revise && bookingSlotId !== undefined) {
        const respBookedSlotUpdated = await this.apiService.bookSlotUpdate(
          bookingSlotId,
          bookingSlot
        );
        if (respBookedSlotUpdated.ok) {
          Mixpanel.track("Booking Slot Updated", {
            bookingSlotObj: bookingSlot,
            bookingSlotId: bookingSlotId,
            estimateDetail: this.state.estimateDetails,
            status: "Booking slot updated successfully"
          });
        } else {
          const resp = await respBookedSlotUpdated.json();
          Mixpanel.track("Booking Slot Updated Error", {
            bookingSlotObj: bookingSlot,
            bookingSlotId: bookingSlotId,
            error: resp.errors,
            estimateDetail: this.state.estimateDetails,
            status: "Booking slot not updated"
          });
        }
      } else {
        const respBookedSlot = await this.apiService.bookSlot(bookingSlot);
        if (respBookedSlot.ok) {
          Mixpanel.track("Booking Slot Added", {
            bookingSlotObj: bookingSlot,
            estimateDetail: this.state.estimateDetails,
            status: "Booking slot added successfully"
          });
        } else {
          const resp = await respBookedSlot.json();
          Mixpanel.track("Booking Slot Added Error", {
            bookingSlotObj: bookingSlot,
            error: resp.errors,
            estimateDetail: this.state.estimateDetails,
            status: "Booking slot not added"
          });
        }
      }
    }
  }

  async sendEmails() {
    const emailTemplates = await this.iBodyShopService.getEmailTemplates(
      this.state.estimateDetails.estimateId.toString()
    );
    const template = emailTemplates.find((template: any) => {
      return template.id === this.defaultEmail;
    });

    if (template) {
      const emailTemplate: Email = {
        body: template.message,
        fromName: "Flow Autobody",
        subject:
          "Booking is completed: " +
          this.state.estimateDetails.estimateNumber.toString(),
        to: [
          this.state.estimateDetails.email
            ? this.state.estimateDetails.email
            : "hello@flowautobody.au"
        ],
        assignedToId: this.state.estimateDetails.estimateId.toString(),
        jobNumber: this.state.estimateDetails.estimateNumber,
        bodyIsHtml: true,
        cc: ["hello@flowautobody.au"]
      };

      const responseOfSendEmail =
        await this.iBodyShopService.sendEmailWithTemplate(emailTemplate);
      if (responseOfSendEmail.ok) {
        Mixpanel.track("Customer Email Send", {
          emailTemplate: emailTemplate,
          estimateDetail: this.state.estimateDetails,
          status: "Email send successfully"
        });
      } else {
        const resp = await responseOfSendEmail.json();
        Mixpanel.track("Customer Email Send Error", {
          emailTemplate: emailTemplate,
          estimateDetail: this.state.estimateDetails,
          error: resp,
          status: "Email not send"
        });
      }
      await this.adminEmail();
    } else {
      const emailBody =
        "Booking has been completed for Estimate: " +
        this.state.estimateDetails.estimateNumber.toString() +
        "<br/>Arrival: " +
        this.state.bookingDate?.format("DD/MMM/YYYY") +
        " at " +
        this.state.bookingSlot.time;
      const emailSubject =
        "Booking completed: " +
        this.state.estimateDetails.estimateNumber.toString();

      const responseOfSendEmail = await this.iBodyShopService.sendEmail(
        emailBody,
        emailSubject,
        this.state.estimateDetails.estimateId.toString(),
        this.state.estimateDetails.email
          ? this.state.estimateDetails.email
          : "hello@flowautobody.com.au"
      );

      if (responseOfSendEmail.ok) {
        Mixpanel.track("Customer Email Send", {
          emailBody,
          emailSubject,
          estimateDetail: this.state.estimateDetails,
          status: "Email send successfully"
        });
      } else {
        const resp = await responseOfSendEmail.json();
        Mixpanel.track("Customer Email Send Error", {
          emailBody,
          emailSubject,
          estimateDetail: this.state.estimateDetails,
          error: resp,
          status: "Email not send"
        });
      }
    }
  }

  async sendNotification(isCancel: boolean, revise?: boolean) {
    let expectedArrival = "";
    if (this.state.bookingDate && moment(this.state.bookingDate).isValid()) {
      expectedArrival = this.getExpectedArrivalDate();
    }
    let htmlContent = `<p>
    <strong ${
      isCancel ? `style='color:#FF0000'` : revise ? `style='color:#30824e'` : ``
    }>${
      isCancel
        ? "Canceled Job Booking"
        : revise
        ? "Revised Job Booking"
        : "Job Booking"
    }</strong> ${
      this.state.estimateDetails.estimateNumber
        ? this.state.estimateDetails.estimateNumber
        : ""
    }
    <br>
    <strong>Customer:</strong> ${
      this.state.estimateDetails?.ownerName
        ? this.state.estimateDetails?.ownerName
        : ""
    }
    <br>
    <strong>Email:</strong> ${
      this.state.estimateDetails?.email ? this.state.estimateDetails?.email : ""
    }
    <br>
    <strong>Contact:</strong> ${
      this.state.estimateDetails?.mobilePhone
        ? this.state.estimateDetails?.mobilePhone
        : ""
    }
    <br>
    ${
      isCancel
        ? ` <strong>Canceled Booking Date:</strong> ${moment(new Date()).format(
            "YYYY-MM-DD HH:mm A"
          )}`
        : ` <strong>Booking Date:</strong> ${expectedArrival}`
    }
    <br>
    ${
      !isCancel
        ? `<strong>Workflow:</strong> <a href="https://app.flowautobody.com/#/planner/booking-calendar">link</a> 
        <br>`
        : ""
    }

    <strong>IBS:</strong> <a href="https://app.ibodyshop.com/#/Estimate/${
      this.state.estimateDetails.estimateId
    }/header">link</a>
    <br>
    ${isCancel ? `<strong>Reason:</strong> ${this.state.canceledReason}` : ``}
  </p>`;
    const userEmail = this.state.estimateDetails?.email
      ? this.state.estimateDetails?.email
      : "";
    const response = await this.apiService.sendTeamsNotification(
      htmlContent,
      userEmail
    );
    this.setState({ canceledReason: "" });
    if (response?.ok) {
      Mixpanel.track("Notification Send", {
        htmlContent: htmlContent,
        userEmail,
        bookingType: isCancel
          ? "Canceled Job Booking"
          : revise
          ? "Revised Job Booking"
          : "Job Booking",
        date: isCancel
          ? moment(new Date()).format("YYYY-MM-DD HH:mm A")
          : expectedArrival,
        estimateDetail: this.state.estimateDetails,
        status: "Notification send successfully"
      });
    } else {
      const resp = await response?.json();
      Mixpanel.track("Notification Send Error", {
        htmlContent,
        userEmail,
        bookingType: isCancel
          ? "Canceled Job Booking"
          : revise
          ? "Revised Job Booking"
          : "Job Booking",
        date: isCancel
          ? moment(new Date()).format("YYYY-MM-DD HH:mm A")
          : expectedArrival,
        estimateDetail: this.state.estimateDetails,
        error: resp,
        status: "Notification not send"
      });
    }
  }

  async sendDefaultSMS() {
    const defaultSMS = {
      estimateId: this.state.estimateDetails.estimateId,
      body: await this.getSMSTemplate()
    };
    const response = await this.ibsService.sendSMS(defaultSMS);
    if (response?.ok) {
      Mixpanel.track("Sms Send", {
        defaultSMS,
        estimateDetail: this.state.estimateDetails,
        status: "Sms send successfully"
      });
    } else {
      const resp = await response?.json();
      Mixpanel.track("Sms Send Error", {
        defaultSMS,
        estimateDetail: this.state.estimateDetails,
        error: resp,
        status: "Sms not send"
      });
    }
  }

  reloadEstimate() {
    // Reload estimate details here
    return this.ibsAdonisService
      .getJobEstimateDetailsById(
        this.state.estimateDetails.estimateNumber.toString()
      )
      .then((data: JobEstimationDetail) => {
        if (data) {
          this.setState({
            estimateDetails: data,
            isBooked: !!data?.expectedArrival,
            bookingSuccessful: false,
            step: 1,
            bookingDate: null,
            bookingSlot: null,
            isRevised: false,
            isVehicleOnSite: !data.isVehicleOnSite,
            slots: [],
            bookingDateError: "",
            bookingMessage: null,
            showLoader: false
          });
          this.props.updateEstimateDetails(data);
        }

        this.selectedAppointment = null;
        this.selectedChecklist = null;
      });
  }

  reviseBooking = async () => {
    // Start loader here
    this.setState({
      showLoader: true
    });
    const obj = {
      jobId: this.state.estimateDetails.estimateId,
      bookingId: this.state.estimateDetails.jobBookingId,
      expectedArrival: "",
      arrivalNotes: "",
      clearArrivalNotes: true
    };
    try {
      const response = await this.ibsService.rescheduleBooking(
        this.state.estimateDetails.estimateId,
        obj
      );
      if (response.ok) {
        Mixpanel.track("Revised Booking", {
          reviseBookinObj: obj,
          estimateDetail: this.state.estimateDetails,
          status: "Booking revised successfully"
        });
      } else {
        const resp = await response.json();
        Mixpanel.track("Revised Booking", {
          reviseBookinObj: obj,
          estimateDetail: this.state.estimateDetails,
          error: resp,
          status: "Booking not revised"
        });
      }
    } catch (err) {
      Mixpanel.track("Revised Booking", {
        reviseBookinObj: obj,
        estimateDetail: this.state.estimateDetails,
        exceptionError: err,
        status: "Booking not revised, exception throws"
      });
      alert(err);
    } finally {
      // Start loader here
      this.setState({
        showLoader: false
      });
    }
  };

  cancelBooking = async () => {
    // Start loader here
    this.setState({
      showLoader: true
    });
    const obj = {
      jobId: this.state.estimateDetails.estimateId,
      bookingId: this.state.estimateDetails.jobBookingId,
      expectedArrival: "",
      arrivalNotes: "",
      clearArrivalNotes: true
    };
    try {
      await this.ibsService
        .rescheduleBooking(this.state.estimateDetails.estimateId, obj)
        .then((res) => {
          res.json().then((resJson) => {
            if (resJson.IsSuccess) {
              this.setState({
                bookingCancel: true
              });
              Mixpanel.track("Booking Cancelled", {
                cancelBookingObj: obj,
                estimateId: this.state.estimateDetails.estimateId,
                estimateDetail: this.state.estimateDetails,
                status: "Booking Cancelled successfully"
              });
            } else {
              Mixpanel.track("Booking Cancelled Error", {
                cancelBookingObj: obj,
                estimateId: this.state.estimateDetails.estimateId,
                estimateDetail: this.state.estimateDetails,
                error: resJson,
                status: "Booking not cancelled"
              });
            }
          });
        });
      await this.deleteAndUpdateBookingTask();
      this.reloadEstimate();
      this.getAppointments();
      this.getPredictedWorkTime();
    } catch (err) {
      Mixpanel.track("Booking Cancelled Error", {
        cancelBookingObj: obj,
        estimateId: this.state.estimateDetails.estimateId,
        estimateDetail: this.state.estimateDetails,
        exceptionError: err,
        status: "Booking not cancelled, throws error"
      });
      alert(err);
    } finally {
      // Start loader here
      this.setState({
        showLoader: false
      });
    }
  };

  async deleteAndUpdateBookingTask() {
    await this.checkChecklist();

    await deleteBookingTask(this.state.estimateDetails.estimateId);
  }

  async adminEmail() {
    const emailTemplates = await this.iBodyShopService.getEmailTemplates(
      this.state.estimateDetails.estimateId.toString(),
      true
    );

    const templateId = "9bcac6f1-ccf2-453e-8175-7ffb66f447a4";

    const template = emailTemplates.find((template: any) => {
      return template.id === templateId;
    });

    const emailTemplate: Email = {
      body: template?.message,
      fromName: "Flow Autobody",
      subject: "Booking Request",
      to: ["hello@flowautobody.au"],
      assignedToId: this.state.estimateDetails.estimateId.toString(),
      jobNumber: this.state.estimateDetails.estimateNumber,
      bodyIsHtml: true,
      cc: []
    };

    const responseOfSendEmail =
      await this.iBodyShopService.sendEmailWithTemplate(emailTemplate);
    if (responseOfSendEmail.ok) {
      Mixpanel.track("Admin Email Send", {
        emailTemplate,
        estimateDetail: this.state.estimateDetails,
        status: "Email send successfully"
      });
    } else {
      const resp = await responseOfSendEmail.json();
      Mixpanel.track("Admin Email Send Error", {
        emailTemplate,
        estimateDetail: this.state.estimateDetails,
        error: resp,
        status: "Email not send"
      });
    }
  }

  async getSMSTemplate() {
    const SMSTemplates = await this.ibsService
      .textMessageSuggestions(this.state.estimateDetails.estimateId)
      .then((res) => res.json());
    return SMSTemplates.find((sms: any) => sms.id === this.defaultSMS).message;
  }

  // async getEmailTemplate() {
  //   const emailTemplates = await this.ibsService
  //     .getEmailTemplates(this.state.estimateDetails.estimateId)
  //     .then((res) => res.json());
  //   return emailTemplates.find((email: any) => email.id === this.defaultEmail)
  //     .message;
  // }

  // async sendDefaultEmail() {
  //   await this.ibsService.sendMail(
  //     JSON.stringify(await this.getEmailTemplate())
  //   );
  // }

  // async sendEmailAndSMS() {
  //   await Promise.all([this.sendDefaultEmail(), this.sendDefaultSMS()]);
  // }

  async checkChecklist() {
    if (this.selectedAppointment) {
      const checklist: Checklist = this.selectedAppointment?.checklist?.filter(
        (x) =>
          x.caption.includes(this.state.estimateDetails.jobNumber.toString()) &&
          !x.checked
      )[0];
      await this.ibsService.updateTask(this.selectedAppointment.id, {
        Title: this.selectedAppointment.summary,
        assignments: [],
        checklistItems: [
          {
            ...checklist,
            isChecked: true
          }
        ]
      });
    }
  }

  closeCancelDialog = (data: any) => {
    this.setState({ showConfirmationOfCancelBooking: false });
  };

  cancelBookingAndCloseDialog = async (reason: string) => {
    this.setState({
      showConfirmationOfCancelBooking: false
    });
    this.setState({
      canceledReason: reason
    });

    await this.cancelBooking();
    if (this.state.bookingCancel) {
      this.addNote(reason);
      this.sendNotification(true);
      this.setState({
        bookingCancel: false
      });
    }
  };

  addNote(reason: string) {
    const estimateId = this.props.estimateDetails.estimateId
      ? this.props.estimateDetails.estimateId
      : this.state.estimateDetails.estimateId;
    if (estimateId) {
      const message =
        "This estimate was canceled by customer the reason that he mentioned is: " +
        reason;
      const data = {
        Note: message,
        IsImportant: true
      };
      this.ibsService.addNote(estimateId, data);
    }
  }

  reviseBookingAndCloseDialog = async () => {
    this.setState({ showConfirmationOfCancelBooking: false });
    this.setState({ isRevised: true });
  };

  render() {
    const app = this.state.allAppointments.filter((x: any) =>
      x.dueDate
        .toLocaleString()
        .includes(
          moment(this.state.estimateDetails?.expectedArrival).format(
            "YYYY-MM-DD"
          )
        )
    )[0];

    if (app) {
      this.selectedAppointment = app;
    }
    // Job is completed
    if (
      this.state.estimateDetails?.expectedPickup &&
      this.state.estimateDetails.isCompleted
    ) {
      return <PickUp estimateDetails={this.state.estimateDetails}></PickUp>;
    }

    if (this.state.isBooked && !this.state.isRevised) {
      return (
        <div className="stepper-control">
          {this.state.bookingCancel ? (
            <Message
              success
              header=""
              content={"Your booking has been canceled"}
            />
          ) : undefined}
          <DisplayBooking
            estimateDetails={this.state.estimateDetails}
            appointment={app}
          ></DisplayBooking>

          {this.state.isVehicleOnSite ? (
            <Grid templateColumns="repeat(2, 1fr)" gap={4}>
              <Button
                colorScheme={"red"}
                variant={"outline"}
                as={GridItem}
                onClick={async () => {
                  if (!this.state.showLoader) {
                    this.setState({ showConfirmationOfCancelBooking: true });
                  }
                }}
                disabled={this.state.showLoader}
              >
                Cancel Booking
                {this.state.showLoader && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginLeft: "5px" }}
                  />
                )}
              </Button>
              <Button
                as={GridItem}
                variant={"solid"}
                colorScheme={"gray"}
                onClick={() => {
                  if (!this.state.showLoader) {
                    this.setState({ isRevised: true });
                  }
                  // this.setState({ showConfirmation: true });
                }}
                disabled={this.state.showLoader}
              >
                Revise Booking
                {this.state.showLoader && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginLeft: "5px" }}
                  />
                )}
              </Button>
            </Grid>
          ) : undefined}

          {this.state.showConfirmationOfCancelBooking ? (
            <CancelBooking
              title={"Cancel Booking"}
              closeDialog={this.closeCancelDialog}
              reviseBooking={this.reviseBookingAndCloseDialog}
              cancelEstimateBooking={this.cancelBookingAndCloseDialog}
            ></CancelBooking>
          ) : undefined}
        </div>
      );
    } else {
      return (
        <div>
          {this.state.isRevised ? (
            <Message
              success
              header=""
              content={
                "You are revising your booking which is for " +
                moment(this.state.estimateDetails?.expectedArrival).format(
                  "ddd, DD/MM/YY hh:mm a"
                )
              }
            />
          ) : undefined}
          {!this.state.showLoader && this.state.appointments.length === 0 && (
            <Message
              error
              header=""
              content="No appointments available for now"
            />
          )}
          {this.state.bookingSuccessful && this.state.bookingMessage && (
            <Message success header="" content={this.state.bookingMessage} />
          )}
          {!this.state.bookingSuccessful && this.state.bookingMessage && (
            <Message error header="" content={this.state.bookingMessage} />
          )}

          <BookingStepper
            step={this.state.step}
            bookingDate={this.state.bookingDate}
            bookingSlot={this.state.bookingSlot}
          ></BookingStepper>
          {this.state.bookingDateError ? (
            <Alert
              borderRadius={4}
              mt={2}
              status="error"
              variant="subtle"
              alignItems={"start"}
              textAlign={"left"}
            >
              <AlertIcon />
              {this.state.bookingDateError}
            </Alert>
          ) : undefined}
          <br></br>
          {this.state.step === 1 ? (
            <BookingCalendar
              estimateDetails={this.state.estimateDetails}
              ibsService={this.iBodyShopService}
              availableAppointments={this.state.appointments}
              onDateSelected={this.onDateSelected}
              selectedDate={this.state.bookingDate}
              bookingAllowance={this.state.bookingAllowance}
            ></BookingCalendar>
          ) : this.state.step === 2 ? (
            <>
              <Text mb={2}>
                Timeslots for {this.state.bookingDate?.format("dddd, DD/MM/YY")}
              </Text>
              {this.state.bookingDate ? (
                <Grid
                  templateColumns={[
                    "repeat(2, 1fr)",
                    "repeat(3, 1fr)",
                    "repeat(auto, 1fr)"
                  ]}
                  flexFlow={"wrap"}
                  gap={2}
                >
                  {this.state.slots.map((x) => (
                    <Appointment
                      key={x.time}
                      time={x.time}
                      id={x.id}
                      onSlotPicked={this.onSlotPicked}
                      isSelected={
                        this.state.bookingSlot &&
                        x.time === this.state.bookingSlot.time
                      }
                    />
                  ))}
                </Grid>
              ) : undefined}
            </>
          ) : this.state.step === 3 ? (
            <Summary
              bookingDate={this.state.bookingDate}
              bookingSlot={this.state.bookingSlot}
              estimateDetails={this.state.estimateDetails}
            ></Summary>
          ) : null}
          <br></br>
          <Grid
            className="stepper-control"
            templateColumns="repeat(2, 1fr)"
            gap={4}
          >
            {this.state.step !== 1 && (
              <Button
                colorScheme={"blackAlpha"}
                variant="outline"
                cursor="pointer"
                as={GridItem}
                w="100%%"
                onClick={() => {
                  if (
                    (this.state.step === 2 || this.state.step === 3) &&
                    !this.state.showLoader
                  ) {
                    this.stepChange(-1);
                  }
                }}
                disabled={this.state.showLoader}
              >
                Back
              </Button>
            )}
            {this.state.step !== 3 && (
              <Button
                colorScheme={"blue"}
                as={GridItem}
                cursor="pointer"
                colStart={2}
                w="100%%"
                onClick={() => this.stepChange(1)}
                disabled={
                  (this.state.step === 1 && !this.state.bookingDate) ||
                  (this.state.step === 2 && !this.state.bookingSlot)
                    ? true
                    : false
                }
              >
                Next
              </Button>
            )}
            {this.state.step === 3 && (
              <Button
                colorScheme={"blue"}
                as={GridItem}
                cursor="pointer"
                colStart={2}
                w="100%%"
                onClick={() => {
                  if (!this.state.showLoader) {
                    if (this.state.isRevised) {
                      this.setState({ showConfirmation: true });
                    } else {
                      this.saveBooking();
                    }
                  }
                }}
                disabled={this.state.showLoader}
              >
                Confirm
                {this.state.showLoader && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginLeft: "5px" }}
                  />
                )}
              </Button>
            )}

            {this.state.showConfirmation ? (
              <MessageDialog
                buttons={
                  <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                    <Button
                      colorScheme={"red"}
                      as={GridItem}
                      w="100%%"
                      onClick={() => {
                        this.setState({ showConfirmation: false });
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      colorScheme={"gray"}
                      as={GridItem}
                      w="100%%"
                      onClick={async () => {
                        if (!this.state.showLoader) {
                          this.setState({ showConfirmation: false });
                          await this.reviseBooking();
                          this.saveBooking(true);
                        }
                      }}
                    >
                      Revise Booking
                    </Button>
                  </Grid>
                }
                closeCallback={() => this.setState({ showConfirmation: false })}
                messageText={
                  "Are you sure you want to revise booking? Your current booking will be canceled"
                }
                title={"Revise Booking"}
              />
            ) : undefined}
          </Grid>
        </div>
      );
    }
  }
}
